export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name':
    'Pixartprinting S.p.A. a socio unico soggetta alla direzione e coordinamento di Cimpress plc',
  'privacy-policy': 'Privacy policy',
  'cookie-policy': 'Cookie policy',
  'informazioni-legali': 'Informazioni legali',
}
